
import React from 'react';
import { useParams, Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Legal: React.FC = () => {
  const { page } = useParams<{ page: string }>();
  
  const renderContent = () => {
    switch (page) {
      case 'impressum':
        return (
          <>
            <h1 className="text-2xl font-bold mb-6">Impressum</h1>
            <div className="prose max-w-none">
              <h2>Angaben gemäß § 5 TMG</h2>
              <p>AdressFinder GmbH<br />
              Musterstraße 123<br />
              12345 Musterstadt</p>
              
              <h3>Kontakt</h3>
              <p>Telefon: +49 123 456789<br />
              E-Mail: info@adressfinder.org</p>
              
              <h3>Registereintrag</h3>
              <p>Eintragung im Handelsregister.<br />
              Registergericht: Amtsgericht Musterstadt<br />
              Registernummer: HRB 12345</p>
              
              <h3>Umsatzsteuer-ID</h3>
              <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:<br />
              DE123456789</p>
            </div>
          </>
        );
      case 'agb':
        return (
          <>
            <h1 className="text-2xl font-bold mb-6">Allgemeine Geschäftsbedingungen</h1>
            <div className="prose max-w-none">
              <h2>1. Geltungsbereich</h2>
              <p>Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge zwischen der AdressFinder GmbH und ihren Kunden bezüglich der Nutzung des Online-Dienstes zur Adressauskunft.</p>
              
              <h2>2. Leistungsbeschreibung</h2>
              <p>AdressFinder.org bietet Online-Adressauskünfte an. Der Dienst ermöglicht es Kunden, Adressdaten von Personen in Deutschland abzufragen, sofern ein berechtigtes Interesse besteht.</p>
              
              <h2>3. Vertragsschluss</h2>
              <p>Der Vertrag kommt durch die Bestellung des Kunden und die Annahme durch AdressFinder.org zustande.</p>
              
              <h2>4. Preise und Zahlungsbedingungen</h2>
              <p>Die Preise für die Nutzung des Dienstes sind auf der Website einsehbar. Die Zahlung erfolgt im Voraus.</p>
              
              <h2>5. Datenschutz</h2>
              <p>AdressFinder.org verpflichtet sich, alle personenbezogenen Daten vertraulich zu behandeln und nur im Rahmen der gesetzlichen Bestimmungen zu verarbeiten.</p>
            </div>
          </>
        );
      case 'datenschutz':
        return (
          <>
            <h1 className="text-2xl font-bold mb-6">Datenschutzerklärung</h1>
            <div className="prose max-w-none">
              <h2>1. Verantwortlicher</h2>
              <p>Verantwortlich für die Verarbeitung Ihrer personenbezogenen Daten ist die AdressFinder GmbH, Musterstraße 123, 12345 Musterstadt.</p>
              
              <h2>2. Erhebung und Verarbeitung personenbezogener Daten</h2>
              <p>Wir erheben und verarbeiten die folgenden personenbezogenen Daten:</p>
              <ul>
                <li>Kontaktdaten (Name, E-Mail-Adresse)</li>
                <li>Daten der gesuchten Person (Name, letzte bekannte Adresse)</li>
                <li>Zahlungsdaten</li>
              </ul>
              
              <h2>3. Zweck der Datenverarbeitung</h2>
              <p>Die Verarbeitung Ihrer Daten erfolgt zum Zweck der Durchführung der von Ihnen beauftragten Adressauskunft sowie zur Abwicklung des Zahlungsverkehrs.</p>
              
              <h2>4. Rechtsgrundlage</h2>
              <p>Die Verarbeitung Ihrer Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) und Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse).</p>
              
              <h2>5. Datensicherheit</h2>
              <p>Wir treffen technische und organisatorische Maßnahmen, um Ihre Daten vor unbefugtem Zugriff zu schützen.</p>
            </div>
          </>
        );
      default:
        return (
          <div className="text-center">
            <h1 className="text-2xl font-bold mb-6">Seite nicht gefunden</h1>
            <p className="mb-6">Die angeforderte Seite existiert nicht.</p>
            <Link to="/" className="text-deep-blue hover:underline">Zurück zur Startseite</Link>
          </div>
        );
    }
  };
  
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow container mx-auto px-4 py-8 max-w-3xl">
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
          {renderContent()}
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default Legal;
